// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"antd-pro_-_-scaffold-src-components-GlobalFooter-globalFooter","links":"antd-pro_-_-scaffold-src-components-GlobalFooter-links","copyright":"antd-pro_-_-scaffold-src-components-GlobalFooter-copyright"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/GlobalFooter/index.less
// module id = 434
// module chunks = 0 1